import { Close } from '@mui/icons-material';
import { Box, Chip, Stack } from '@mui/material';
import type { AutocompleteOption, ChipDisplayProps } from './types';

export const ChipDisplay = <T extends AutocompleteOption>({
  items,
  onRemove,
  chipSx = {},
  maxItems, // Reserved for future use
  maxItemsMessage, // Reserved for future use
}: ChipDisplayProps<T>) => {
  void maxItems;
  void maxItemsMessage;

  if (items.length === 0) return null;

  const defaultRenderChip = (option: T, onDelete: () => void) => (
    <Chip
      data-testid={`selected-stock-${option.label}`}
      label={option.label}
      onDelete={onDelete}
      deleteIcon={<Close sx={{ fontSize: '18px' }} />}
      sx={{
        mb: 1,
        backgroundColor: '#667eea',
        color: 'white',
        fontWeight: 500,
        minHeight: '32px',
        '&:hover': {
          backgroundColor: '#5a6fd8',
        },
        '& .MuiChip-deleteIcon': {
          color: theme => theme.chart.white.text,
          fontSize: '18px',
          '&:hover': {
            color: 'white',
          },
        },
        ...chipSx,
      }}
    />
  );

  return (
    <Box sx={{ mt: 2 }}>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {items.map((item, index) => {
          const handleDelete = () => onRemove(item);

          const uniqueKey = `${item.id}-${index}`;

          return <Box key={uniqueKey}>{defaultRenderChip(item, handleDelete)}</Box>;
        })}
      </Stack>
    </Box>
  );
};
